import React from 'react';
import { AssignmentDisplayData } from 'types/assignment';
import { AssignmentDetails } from './assignmentDetails';
import { CondominiumData } from './condominiumData';
import { CondominiumImplantData } from './condominiumImplant';
import { ActivityData } from './activityData';
import style from '../../style.module.scss';
import { DetailsSingleDatum } from './detailsSingleDatum';
import { AppplicantView } from './applicantView';
import { ForwardDetails } from './forwardDetails';
import { nullcheckAllObjProperty } from 'utils/object';

type Props = { assignment: AssignmentDisplayData };

export const DesktopView: React.FC<Props> = ({
  assignment: { details, condominium, condominumImplant, activity, pid, forward }
}) => (
  <div className={style['assignment-container']}>
    <h5 className="semibold">Richiesta di intervento a {details.fornitoreNome}&#58;</h5>
    {nullcheckAllObjProperty(forward) && (
      <div className="row no-gutters pt-3">
        <div className="col-12">
          <ForwardDetails forward={forward} />
        </div>
      </div>
    )}
    <div className="row no-gutters">
      <div className="col-4">
        <AssignmentDetails details={details} pid={pid} />
      </div>
      <div className="col-4 pl-4">
        <DetailsSingleDatum title="Amministratore" value={details.amministratoreNome} />
        <CondominiumData condominium={condominium} />
      </div>
      <div className="col-4 pl-4">
        <DetailsSingleDatum title="Operatore" value={details.attivitaOperatore} />
        <AppplicantView
          attivitaReferente={details.attivitaReferente}
          attivitaReferenteContatto={details.attivitaReferenteContatto}
        />
        <CondominiumImplantData condominumImplant={condominumImplant} />
      </div>
    </div>
    <h6 className="semibold font__grey">Attività</h6>
    <ActivityData activity={activity} />
  </div>
);
